import { CloseOutlined } from '@mui/icons-material';
import { Alert, Box, Button, Divider, IconButton, StepConnector, TextField, Typography } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import styled from 'styled-components';
import ComponentWrapper from 'ui/templates/ComponentWrapper/ComponentWrapper';

interface Props {
  handleClose: () => void;
  descriptionInputValue: string;
  setDescriptionInputValue: React.Dispatch<React.SetStateAction<string>>;
  handleBlockCard: () => void;
}

const StyledStepConnector = styled(StepConnector)`
  & span {
    height: 100%;
  }
`;

const BlockCard: React.FC<React.PropsWithChildren<Props>> = ({
  handleClose,
  descriptionInputValue,
  handleBlockCard,
  setDescriptionInputValue
}) => {
  const { translation } = useTranslation();

  return (
    <Box
      id="block-card-modal"
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: '#252525',
        border: '1px solid #444',
        borderRadius: '4px'
      }}
    >
      <ComponentWrapper width="444px" flexDirection="column">
        <ComponentWrapper padding="16px 24px" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" color="textPrimary">
            {translation.block}
          </Typography>
          <IconButton onClick={handleClose} style={{ padding: '4px' }}>
            <CloseOutlined style={{ color: 'rgba(255, 255, 255, 0.56)' }} />
          </IconButton>
        </ComponentWrapper>
        <Divider />
        <ComponentWrapper padding="16px 24px" flexDirection="column" gap="24px">
          <Typography variant="body2" color="textPrimary">
            {translation.block_card_confirmation}
          </Typography>
          <TextField
            onChange={(event) => setDescriptionInputValue(event.target.value)}
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            size="medium"
            multiline
            placeholder={translation.block_card_description_placeholder}
            label={translation.description}
            value={descriptionInputValue}
            id="drawer-input-reason"
          />
          <Alert variant="standard" severity="info" style={{ backgroundColor: 'rgba(41, 182, 246, 0.08)' }}>
            <ComponentWrapper flexDirection="column">
              <Typography
                fontSize="16px"
                lineHeight="150%"
                fontWeight="500"
                letterSpacing="0.15px"
                style={{ color: 'rgba(184, 231, 251, 1)' }}
              >
                {translation.please_synchronize_locks}
              </Typography>
              <Typography variant="body2" style={{ color: 'rgba(184, 231, 251, 1)' }}>
                {translation.an_installer_must_synchronize_all_locks_with_the_config_app_for_this_card_to_be_blocked}
              </Typography>
            </ComponentWrapper>
          </Alert>
        </ComponentWrapper>
        <Divider />
        <ComponentWrapper padding="8px" alignItems="center" justifyContent="end" gap="8px">
          <Button onClick={handleClose} size="medium" variant="text" style={{ color: 'rgba(255, 255, 255, 0.87) ' }}>
            {translation.cancel}
          </Button>
          <Button
            onClick={handleBlockCard}
            size="medium"
            color="error"
            variant="contained"
            id="block-card-confirm-button"
          >
            {translation.block}
          </Button>
        </ComponentWrapper>
      </ComponentWrapper>
    </Box>
  );
};

export default BlockCard;
